import * as types from './mutation-types'
import Vue from 'vue'
const constants = require('@/util/constants')

export default {

  /**
   * 重新加载页面初始化token
   */
  [types.INIT](state) {
    let data = localStorage.getItem(types.LOCALSTORAGE_PASSPORT_TOKEN_KEY)
    if (data) {
      state.passport.token = JSON.parse(data)
      localStorage.access_token = state.passport.token.access_token
    }
  },

  /**
   * 登录成功后，持久化token
   */
  [types.PERSIST_PASSPORT_TOKEN](state, { token }) {
    state.passport.token = token
    localStorage.access_token = token.access_token
    localStorage.setItem(types.LOCALSTORAGE_PASSPORT_TOKEN_KEY, JSON.stringify(token))
  },

  /**
   * 退出登录，清空本地登录状态token
   */
  [types.LOGOUT](state) {
    localStorage.removeItem('access_token')
    localStorage.removeItem(types.LOCALSTORAGE_PASSPORT_TOKEN_KEY)
    state.passport.token.access_token = ''
  },

  /**
   * 根据角色权限确定是否显示/隐藏某功能模块
   */
  [types.UPDATE_SHOW_AUTHORITY](state) {
    // 还原
    state.user.show_authority.home = false
    state.user.show_authority.statistic = false
    state.user.show_authority.chat = true
    state.user.show_authority.thread = true
    state.user.show_authority.visitor = true
    state.user.show_authority.history = true
    state.user.show_authority.monitor = false
    state.user.show_authority.quality = false
    state.user.show_authority.robot = false
    state.user.show_authority.support = false
    state.user.show_authority.setting = true
    state.user.show_authority.feedback = false
    state.user.show_authority.workorder = false
    state.user.show_authority.callcenter = false
    state.user.show_authority.crm = false
    state.user.show_authority.wenjuan = false
    state.user.show_authority.internal = false
    //
    state.user.show_authority.admin = false
    state.user.show_authority.debug = false
    state.user.show_authority.free = false
    state.user.show_authority.try = false
    state.user.show_authority.vip = false
    //
    state.show_bottom_statistics = Vue.ls.get(constants.SHOW_BOTTOM_STATISTIC, true)
    // 重新设置
    for (let i = 0; i < state.user.info.roles.length; i++) {
      const role = state.user.info.roles[i]
      // 超级管理员
      if (role.value === constants.ROLE_SUPER) {
        state.user.show_authority.debug = true
        state.user.show_authority.admin = true
      }
      // 注册管理员
      if (role.value === constants.ROLE_ADMIN) {
        state.user.show_authority.admin = true
      }
      // 免费用户
      // if (role.value === constants.ROLE_FREE) {
      //   state.user.show_authority.free = true
      // }
      // 试用用户
      // if (role.value === constants.ROLE_TRY) {
      //   state.user.show_authority.admin = true
      //   state.user.show_authority.try = true
      // }
      // 付费用户
      // if (role.value === constants.ROLE_VIP) {
      //   state.user.show_authority.admin = true
      //   state.user.show_authority.vip = true
      // }
      // 付费、试用
      if (role.value === constants.ROLE_SUPER
        // role.value === constants.ROLE_VIP ||
        // role.value === constants.ROLE_TRY
      ) {
        state.user.show_authority.home = true
        state.user.show_authority.statistic = true
        state.user.show_authority.history = true
        state.user.show_authority.monitor = true
        state.user.show_authority.quality = true
        state.user.show_authority.robot = true
        state.user.show_authority.support = true
        state.user.show_authority.feedback = true
        state.user.show_authority.workorder = true
        state.user.show_authority.callcenter = true
        state.user.show_authority.crm = true
        state.user.show_authority.wenjuan = true
        state.user.show_authority.internal = true
      }
    }
  },

  /**
   * 持久化自动回复历史
   */
  [types.QUERY_AUTO_REPLY](state, { autoReplyList }) {
    state.user.autoReplyList = autoReplyList
  },

  /**
   * 通过设置用户信息，存储自动回复信息
   */
  [types.PERSIST_AUTO_REPLY](state, { info }) {
    state.user.info = info
  },

  /**
   * 删除持久化自动回复
   */
  [types.DELETE_AUTO_REPLY](state, { aid }) {
    for (let index = state.user.autoReplyList.length - 1; index >= 0; index--) {
      const element = state.user.autoReplyList[index]
      // console.log('delete:', element.aid, aid)
      if (element.aid === aid) {
        state.user.autoReplyList.splice(index, 1)
      }
    }
  },

  /**
   * 登录成功后，持久化username
   */
  [types.PERSIST_USER_INFO](state, { info }) {
    state.user.info = info
    for (let i = 0; i < info.roles.length; i++) {
      const role = info.roles[i]
      if (role.value === 'ROLE_ADMIN' || role.value === 'ROLE_WORKGROUP_ADMIN') {
        state.user.is_admin = true
      }
    }
    Vue.ls.set(constants.USER_INFO_UID, info.uid)
  },

  // [types.PERSIST_USER_INFO_CACHE](state, { info }) {
  //   state.user.info = info
  // },

  /**
   * 持久化在线状态
   */
  [types.PERSIST_ACCEPT_STATUS](state, { status }) {
    // state.user.settings.accept_status = status
    state.user.info.acceptStatus = status
  },

  /**
   * 持久化视频客服在线状态
   */
  [types.PERSIST_WEBRTC_STATUS](state, { status }) {
    state.user.info.webrtcStatus = status
  },

  /**
   * 持久化当前用户所属会话
   */
  [types.PERSIST_USER_THREADS](state, { threads }) {
    state.user.threads = threads
    for (let i = 0; i < threads.length; i++) {
      const thread = threads[i]
      if (thread.current) {
        // 设置当前会话
        this.commit(types.UPDATE_CURRENT_THREAD, { thread })
      }
    }
  },

  [types.INIT_USER_THREAD](state, { thread }) {
    // 列表中一个用户仅能够存在一条会话
    for (let i = state.user.threads.length - 1; i >= 0; i--) {
      const thd = state.user.threads[i]
      if (thd.topic === thread.topic) {
        // 如果已经存在，则清除掉
        state.user.threads.splice(i, 1)
      }
    }
    state.user.threads.unshift(thread)
  },

  // 清空用户会话
  [types.CLEAR_USER_THREADS](state) {
    state.user.threads = []
  },

  /**
   * 添加thread
   */
  [types.ADD_USER_THREAD](state, { thread }) {
    // 列表中一个用户仅能够存在一条会话
    // 上线、离线消息不增加未读数目
    let shouldIncreaseUnreadCount = false
    if (thread.uid === constants.SYSTEM_NOTIFICATION_USER_UUID ||
      thread.uid === state.user.info.uid) { // 此uid为系统通知用户uid 或者 客服自己
      shouldIncreaseUnreadCount = true
    }
    // 频道会话
    if (thread.type === constants.THREAD_TYPE_CHANNEL) {
      let contains = false
      for (let i = state.user.channel_threads.length - 1; i >= 0; i--) {
        const thd = state.user.channel_threads[i]
        if (thd.topic === thread.topic) {
          contains = true
          state.user.channel_threads.splice(i, 1)
          // 非当前会话
          if (state.user.current_thread.topic !== thread.topic) {
          } else {
            state.user.current_thread = thread
          }
        }
      }
      state.user.channel_threads.unshift(thread)
      return
    }
    // 同事会话
    if (thread.type === constants.THREAD_TYPE_CONTACT) {
      let contains = false
      for (let i = state.user.contact_threads.length - 1; i >= 0; i--) {
        const thd = state.user.contact_threads[i]
        if (thd.topic === thread.topic) {
          contains = true
          state.user.contact_threads.splice(i, 1)
          // 非当前会话
          if (state.user.current_thread.topic !== thread.topic) {
          } else {
            state.user.current_thread = thread
          }
        }
      }
      state.user.contact_threads.unshift(thread)
      return
    }
    // 群组会话
    if (thread.type === constants.THREAD_TYPE_GROUP) {
      let contains = false
      for (let i = state.user.group_threads.length - 1; i >= 0; i--) {
        const thd = state.user.group_threads[i]
        if (thd.topic === thread.topic) {
          contains = true
          state.user.group_threads.splice(i, 1)
          // 非当前会话
          if (state.user.current_thread.topic !== thread.topic) {
          } else {
            state.user.current_thread = thread
          }
        }
      }
      state.user.group_threads.unshift(thread)
      return
    }
    // 工单
    if (thread.type === constants.THREAD_TYPE_TICKET_WORKGROUP ||
      thread.type === constants.THREAD_TYPE_TICKET_APPOINTED) {
      let forMeReplyContains = false
      for (let i = state.user.formereply_tickets.content.length - 1; i >= 0; i--) {
        let ticket = state.user.formereply_tickets.content[i]
        if (ticket.thread.tid === thread.tid) {
          forMeReplyContains = true
          // 非当前会话
          if (state.user.current_thread.tid !== thread.tid) {
            if (!shouldIncreaseUnreadCount) {
              thread.unreadCount = ticket.thread.unreadCount + 1
            } else {
              thread.unreadCount = ticket.thread.unreadCount
            }
          }
          ticket.thread = thread
          // 
          state.user.formereply_tickets.content.splice(i, 1)
          state.user.formereply_tickets.content.unshift(ticket)
        }
      }
      if (forMeReplyContains) {
        return
      }
      // 
      let toBeRepliedContains = false
      for (let i = state.user.tobereplied_tickets.content.length - 1; i >= 0; i--) {
        let ticket = state.user.tobereplied_tickets.content[i]
        if (ticket.thread.tid === thread.tid) {
          toBeRepliedContains = true
          // 非当前会话
          if (state.user.current_thread.tid !== thread.tid) {
            if (!shouldIncreaseUnreadCount) {
              thread.unreadCount = ticket.thread.unreadCount + 1
            } else {
              thread.unreadCount = ticket.thread.unreadCount
            }
          }
          ticket.thread = thread
          // 
          state.user.tobereplied_tickets.content.splice(i, 1)
          state.user.tobereplied_tickets.content.unshift(ticket)
        }
      }
      if (toBeRepliedContains) {
        return
      }
      // 
      let doneContains = false
      for (let i = state.user.done_tickets.content.length - 1; i >= 0; i--) {
        let ticket = state.user.done_tickets.content[i]
        if (ticket.thread.tid === thread.tid) {
          doneContains = true
          // 非当前会话
          if (state.user.current_thread.tid !== thread.tid) {
            if (!shouldIncreaseUnreadCount) {
              thread.unreadCount = ticket.thread.unreadCount + 1
            } else {
              thread.unreadCount = ticket.thread.unreadCount
            }
          }
          ticket.thread = thread
          // 
          state.user.done_tickets.content.splice(i, 1)
          state.user.done_tickets.content.unshift(ticket)
        }
      }
      if (doneContains) {
        return
      }
      // 
      let ignoreContains = false
      for (let i = state.user.ignored_tickets.content.length - 1; i >= 0; i--) {
        let ticket = state.user.ignored_tickets.content[i]
        if (ticket.thread.tid === thread.tid) {
          ignoreContains = true
          // 非当前会话
          if (state.user.current_thread.tid !== thread.tid) {
            if (!shouldIncreaseUnreadCount) {
              thread.unreadCount = ticket.thread.unreadCount + 1
            } else {
              thread.unreadCount = ticket.thread.unreadCount
            }
          }
          ticket.thread = thread
          // 
          state.user.ignored_tickets.content.splice(i, 1)
          state.user.ignored_tickets.content.unshift(ticket)
        }
      }
      if (ignoreContains) {
        return
      }
      // 
      let closedContains = false
      for (let i = state.user.closed_tickets.content.length - 1; i >= 0; i--) {
        let ticket = state.user.closed_tickets.content[i]
        if (ticket.thread.tid === thread.tid) {
          closedContains = true
          // 非当前会话
          if (state.user.current_thread.tid !== thread.tid) {
            if (!shouldIncreaseUnreadCount) {
              thread.unreadCount = ticket.thread.unreadCount + 1
            } else {
              thread.unreadCount = ticket.thread.unreadCount
            }
          }
          ticket.thread = thread
          // 
          state.user.closed_tickets.content.splice(i, 1)
          state.user.closed_tickets.content.unshift(ticket)
        }
      }
      if (closedContains) {
        return
      }
      return
    }
    // 置顶会话
    let topContains = false
    for (let i = state.user.top_threads.length - 1; i >= 0; i--) {
      const thd = state.user.top_threads[i]
      if (thd.topic === thread.topic) {
        topContains = true
        state.user.top_threads.splice(i, 1)
        // 非当前会话
        if (state.user.current_thread.topic !== thread.topic) {
          if (!shouldIncreaseUnreadCount) {
            thread.unreadCount = thd.unreadCount + 1
          } else {
            thread.unreadCount = thd.unreadCount
          }
        } else {
          state.user.current_thread = thread
        }
        //
        state.user.top_threads.unshift(thread)
      }
    }
    if (topContains) {
      return
    }
    // 星标1
    let star1Contains = false
    for (let i = state.user.star1_threads.length - 1; i >= 0; i--) {
      const thd = state.user.star1_threads[i]
      if (thd.topic === thread.topic) {
        star1Contains = true
        state.user.star1_threads.splice(i, 1)
        // 非当前会话
        if (state.user.current_thread.topic !== thread.topic) {
          if (!shouldIncreaseUnreadCount) {
            thread.unreadCount = thd.unreadCount + 1
          } else {
            thread.unreadCount = thd.unreadCount
          }
        } else {
          state.user.current_thread = thread
        }
        //
        state.user.star1_threads.unshift(thread)
      }
    }
    if (star1Contains) {
      return
    }
    // 星标2
    let star2Contains = false
    for (let i = state.user.star2_threads.length - 1; i >= 0; i--) {
      const thd = state.user.star2_threads[i]
      if (thd.topic === thread.topic) {
        star2Contains = true
        state.user.star2_threads.splice(i, 1)
        // 非当前会话
        if (state.user.current_thread.topic !== thread.topic) {
          if (!shouldIncreaseUnreadCount) {
            thread.unreadCount = thd.unreadCount + 1
          } else {
            thread.unreadCount = thd.unreadCount
          }
        } else {
          state.user.current_thread = thread
        }
        //
        state.user.star2_threads.unshift(thread)
      }
    }
    if (star2Contains) {
      return
    }
    // 星标3
    let star3Contains = false
    for (let i = state.user.star3_threads.length - 1; i >= 0; i--) {
      const thd = state.user.star3_threads[i]
      if (thd.topic === thread.topic) {
        star3Contains = true
        state.user.star3_threads.splice(i, 1)
        // 非当前会话
        if (state.user.current_thread.topic !== thread.topic) {
          if (!shouldIncreaseUnreadCount) {
            thread.unreadCount = thd.unreadCount + 1
          } else {
            thread.unreadCount = thd.unreadCount
          }
        } else {
          state.user.current_thread = thread
        }
        //
        state.user.star3_threads.unshift(thread)
      }
    }
    if (star3Contains) {
      return
    }
    // 星标4
    let star4Contains = false
    for (let i = state.user.star4_threads.length - 1; i >= 0; i--) {
      const thd = state.user.star4_threads[i]
      if (thd.topic === thread.topic) {
        star4Contains = true
        state.user.star4_threads.splice(i, 1)
        // 非当前会话
        if (state.user.current_thread.topic !== thread.topic) {
          if (!shouldIncreaseUnreadCount) {
            thread.unreadCount = thd.unreadCount + 1
          } else {
            thread.unreadCount = thd.unreadCount
          }
        } else {
          state.user.current_thread = thread
        }
        //
        state.user.star4_threads.unshift(thread)
      }
    }
    if (star4Contains) {
      return
    }
    // 进行中会话列表
    let contains = false
    for (let i = state.user.threads.length - 1; i >= 0; i--) {
      const thd = state.user.threads[i]
      if (thd.topic === thread.topic) {
        contains = true
        state.user.threads.splice(i, 1)
        // 非当前会话
        if (state.user.current_thread.topic !== thread.topic) {
          if (!shouldIncreaseUnreadCount) {
            thread.unreadCount = thd.unreadCount + 1
          } else {
            thread.unreadCount = thd.unreadCount
          }
        } else {
          state.user.current_thread = thread
        }
      }
    }
    // TODO: 存在bug，待完善
    //  && (thread.type === constants.THREAD_TYPE_WORKGROUP || thread.type === constants.THREAD_TYPE_APPOINTED)
    if (!contains && !shouldIncreaseUnreadCount) {
      thread.unreadCount = 1
    }
    state.user.threads.unshift(thread)
  },

  /**
   * 关闭会话:
   * 更新会话为关闭状态
   */
  [types.CLOSE_USER_THREAD](state, { tid }) {
    for (let i = state.user.threads.length - 1; i >= 0; i--) {
      if (state.user.threads[i].tid === tid) {
        // console.log('close thread:', tid)
        state.user.threads[i].closed = true
      }
    }
  },

  /**
   * 删除会话
   */
  [types.REMOVE_USER_THREAD](state, { tid }) {
    for (let i = state.user.threads.length - 1; i >= 0; i--) {
      // console.log('remove:', state.user.threads[i].tid, tid)
      if (state.user.threads[i].tid === tid) {
        // console.log('remove thread:', tid)
        for (let j = 0; j < state.history_records.content.length; j++) {
          const historyThread = state.history_records.content[j];
          if (historyThread.topic === state.user.threads[i].topic ||
            historyThread.tid === state.user.threads[i].tid) {
            state.history_records.content.splice(j, 1)
          }
        }
        // let contains = state.history_records.content.some(thread => {
        //   return thread.topic === state.user.threads[i].topic
        // })
        // if (!contains) {
        //   state.history_records.content.unshift(state.user.threads[i])
        // }
        state.user.threads[i].unreadCount = 0
        state.history_records.content.unshift(state.user.threads[i])
        state.user.threads.splice(i, 1)
        //
        if (state.user.current_thread.tid === tid) {
          // state.user.current_thread.tid = ''
          // state.user.current_thread.topic = ''
        }
      }
    }
  },

  // 重新开始会话
  [types.RESTART_USER_THREAD](state, { tid }) {
    //
    for (let j = 0; j < state.history_records.content.length; j++) {
      let historyThread = state.history_records.content[j];
      historyThread.closed = false
      if (historyThread.tid === tid) {
        state.history_records.content.splice(j, 1)
        state.user.threads.unshift(historyThread)
      }
    }
  },

  // 监控-机器人会话-进行中
  [types.PERSIST_ROBOT_THREAD_ONGOING](state, { threads }) {
    state.robot_threads_ongoing = threads
  },

  [types.REMOVE_ROBOT_THREAD_ONGOING](state, { tid }) {
    console.log('REMOVE_ROBOT_THREAD_ONGOING:', tid)
    for (let i = state.robot_threads_ongoing.length - 1; i >= 0; i--) {
      console.log('remove:', state.robot_threads_ongoing[i].tid, tid)
      if (state.robot_threads_ongoing[i].tid === tid) {
        console.log('remove thread:', tid)
        // for (let j = 0; j < state.robot_threads_closed.length; j++) {
        //   const closedThread = state.robot_threads_closed[j];
        //   if (closedThread.topic === state.robot_threads_ongoing[i].topic ||
        //     closedThread.tid === state.robot_threads_ongoing[i].tid) {
        //     state.robot_threads_closed.splice(j, 1)
        //   }
        // }
        // state.robot_threads_closed.unshift(state.robot_threads_ongoing[i])
        state.robot_threads_ongoing.splice(i, 1)
      }
    }
  },

  // 监控-机器人会话-以关闭
  [types.PERSIST_ROBOT_THREAD_CLOSED](state, { threads }) {
    state.robot_threads_closed = threads
  },

  /**
   * 持久化queues
   */
  [types.PERSIST_USER_QUEUES](state, { queues }) {
    state.user.queues = queues
  },

  /**
   * 持久化一条queue
   */
  [types.ADD_USER_QUEUE](state, { queue }) {
    let contains = state.user.queues.content.some(que => {
      return que.qid === queue.qid
    })
    if (!contains) {
      state.user.queues.content.unshift(queue)
    }
  },

  /**
   * 接入一条queue
   */
  [types.ACCEPT_USER_QUEUE](state, { qid }) {
    for (let i = 0; i < state.user.queues.content.length; i++) {
      const queue = state.user.queues.content[i]
      if (queue.qid === qid) {
        state.user.queues.content.splice(i, 1)
      }
    }
    state.user.current_queue = {
      qid: '',
      visitor: {
        nickname: '',
        avatar: '',
        description: ''
      }
    }
  },

  [types.IGNORE_USER_QUEUE](state, { qid }) {
    for (let i = 0; i < state.user.queues.content.length; i++) {
      const queue = state.user.queues.content[i]
      if (queue.qid === qid) {
        state.user.queues.content.splice(i, 1)
      }
    }
    state.user.current_queue = {
      qid: '',
      visitor: {
        nickname: '',
        avatar: '',
        description: ''
      }
    }
  },

  /**
   * 持久化同事列表
   */
  [types.PERSIST_USER_CONTACTS](state, { contacts }) {
    state.user.contacts = contacts
  },

  /**
   * 设置当前联系人
   * 注意：contact类型为user
   */
  [types.UPDATE_CURRENT_CONTACT](state, { contact }) {
    // 当前会话类型
    state.user.current_contact = contact
  },

  /**
   * 更新thread内容和时间戳
   */
  [types.UPDATE_THREAD_CONTENT](state, { tid, content, timestamp, unreadCount }) {
    for (let i = state.user.threads.length - 1; i >= 0; i--) {
      if (state.user.threads[i].tid === tid) {
        state.user.threads[i].content = content
        state.user.threads[i].timestamp = timestamp
        state.user.threads[i].unreadCount = unreadCount
      }
    }
  },

  /**
   * 持久化当前用户所属工作组
   */
  [types.PERSIST_USER_WORKGROUPS](state, { workGroups }) {
    state.user.workGroups = workGroups
  },

  /**
   * 持久化当前用户所属群组
   */
  [types.PERSIST_USER_GROUPS](state, { groups }) {
    state.user.groups = groups
  },

  [types.ADD_USER_GROUP](state, { group }) {
    state.user.groups.unshift(group)
  },

  /**
   * 设置当前群组
   * 注意：group类型为workGroup
   */
  [types.UPDATE_CURRENT_GROUP](state, { group }) {
    // 当前会话类型
    state.user.current_group = group
  },

  /**
   * 设置当前会话类型
   */
  [types.UPDATE_CURRENT_CHAT_TYPE](state, { type, object }) {
    state.user.current_chat_type = type
    if (type === constants.THREAD_TYPE_WORKGROUP || type === constants.THREAD_TYPE_APPOINTED) {
      state.user.current_thread = object
    } else if (type === constants.THREAD_TYPE_CONTACT) {
      state.user.current_contact = object
    } else if (type === constants.THREAD_TYPE_GROUP) {
      state.user.current_group = object
    }
  },

  /**
   * 添加工作组
   */
  // [types.ADD_USER_WORKGROUP](state, { workGroup }) {
  //   let contains = state.user.workGroups.some(wg => {
  //     return wg.wid === workGroup.wid
  //   })
  //   if (!contains) {
  //     state.user.workGroups.unshift(workGroup)
  //   }
  // },

  /**
   * 持久化聊天记录
   */
  [types.PERSIST_USER_MESSAGES](state, { messages }) {
    state.user.messages = messages
  },

  /**
   * 添加聊天记录
   * 更新消息状态
   */
  [types.ADD_USER_MESSAGE](state, { message }) {
    // let contains = state.user.messages.some(msg => {
    //   return msg.mid === message.mid
    // })
    // if (!contains) {
    //   state.user.messages.unshift(message)
    // }
    //
    let contains = false
    for (let i = state.user.messages.length - 1; i >= 0; i--) {
      const msg = state.user.messages[i]
      if (msg.mid === message.mid) {
        state.user.messages.splice(i, 1, message)
        // state.user.messages.unshift(message)
        contains = true
      }
    }
    if (!contains) {
      state.user.messages.unshift(message)
    }
  },

  /**
   * protobuf message
   */
  [types.ADD_PROTOBUF_MESSAGE](state, { message }) {
    if (message.type === constants.MESSAGE_TYPE_NOTIFICATION_CONNECT ||
      message.type === constants.MESSAGE_TYPE_NOTIFICATION_DISCONNECT) {
      // 消息列表不显示访客上下线消息
      return
    }
    let contains = false
    for (let i = 0; i < state.user.protobufMessages.length; i++) {
      const element = state.user.protobufMessages[i]
      if (message.mid === element.mid) {
        contains = true
        // 将从服务器加载下来的消息跟本地消息发送状态对比，如果为发送状态，则替换
        // if (element.status === constants.MESSAGE_STATUS_SENDING) {
        state.user.protobufMessages.splice(i, 1, message) // 替换
        // }
        // state.user.protobufMessages.splice(i, 1)
      }
    }
    // let contains = state.user.protobufMessages.some(msg => {
    //   return msg.mid === message.mid
    // })
    if (!contains) {
      state.user.protobufMessages.push(message)
    }
  },

  /**
   * 持久化
   * @param {*} state 
   * @param {*} param1 
   */
  [types.PERSIST_COMMODITY_MESSAGES](state, { messages }) {
    state.user.commodityMessages = messages
    // 去重
    // for (let index = 0; index < messages.length; index++) {
    //   const message = messages[index]
    //   //
    //   let contains = false
    //   for (let i = 0; i < state.user.commodityMessages.length; i++) {
    //     const element = state.user.commodityMessages[i]
    //     if (message.mid === element.mid) {
    //       contains = true
    //     }
    //   }
    //   if (!contains) {
    //     state.user.commodityMessages.push(message)
    //   }
    // }
  },

  [types.CLEAR_COMMODITY_MESSAGES](state) {
    state.user.commodityMessages = []
  },

  /**
   * 更新加载更多信息
   */
  // [types.UPDATE_LOAD_MESSAGE_PAGE](state, { uid, page, first, last, totalElements }) {
  [types.UPDATE_LOAD_MESSAGE_PAGE](state, { last }) {
    state.user.current_thread_more.last = last
    // let contains = false
    // for (let i = 0; i < state.user.mores.length; i++) {
    //   if (state.user.mores[i].uid === uid) {
    //     // 包含，则更新
    //     contains = true
    //     state.user.mores[i].page = page + 1
    //     state.user.mores[i].first = first
    //     state.user.mores[i].last = last
    //     state.user.mores[i].totalElements = totalElements
    //     //
    //     state.user.current_thread.page = page + 1
    //     state.user.current_thread.first = first
    //     state.user.current_thread.last = last
    //     state.user.current_thread.totalElements = totalElements
    //   }
    // }
    // if (!contains) {
    //   // 不包含，则插入
    //   let more = {
    //     uid: uid,
    //     page: page + 1,
    //     first: first,
    //     last: last,
    //     totalElements: totalElements
    //   }
    //   state.user.mores.unshift(more)
    // }
  },

  [types.UPDATE_USER_MESSAGE](state, { mid, status }) {
    // console.log('muation: ', mid, status)
    for (let i = state.user.protobufMessages.length - 1; i >= 0; i--) {
      const msg = state.user.protobufMessages[i]
      if (msg.mid === mid) {
        // console.log('do update:', mid)
        // TODO: 可更新顺序 read > received > stored > sending, 前面的状态可更新后面的
        if (state.user.protobufMessages[i].status === constants.MESSAGE_STATUS_READ) {
          return
        }
        state.user.protobufMessages[i].status = status
      }
    }
  },

  [types.UPDATE_MESSAGE_ADD_TRANSLATE](state, { mid, content }) {
    // console.log('muation: ', mid, status)
    for (let i = state.user.protobufMessages.length - 1; i >= 0; i--) {
      const msg = state.user.protobufMessages[i]
      if (msg.mid === mid) {
        // console.log('do update:', mid)
        state.user.protobufMessages[i].content = content
      }
    }
  },

  [types.UPDATE_THREAD_DELAY](state, { tid, delay }) {
    // console.log('muation: ', mid, status)
    for (let i = state.user.threads.length - 1; i >= 0; i--) {
      const thread = state.user.threads[i]
      if (thread.tid === tid) {
        Vue.set(state.user.threads[i], 'delay', delay)
      }
    }
  },

  [types.DELETE_USER_MESSAGE](state, { mid }) {
    for (let i = state.user.protobufMessages.length - 1; i >= 0; i--) {
      const msg = state.user.protobufMessages[i]
      if (msg.mid === mid) {
        console.log('do delete:', mid)
        state.user.protobufMessages.splice(i, 1)
      }
    }
    // for (let i = state.user.messages.length - 1; i >= 0; i--) {
    //   const msg = state.user.messages[i]
    //   if (msg.mid === mid) {
    //     // console.log('do delete:', mid)
    //     state.user.messages.splice(i, 1)
    //   }
    // }
  },

  /**
   * 浏览中访客相关
   */
  [types.PERSIST_USER_BROWSES](state, { browses }) {
    state.user.browses = browses
  },

  [types.ADD_USER_BROWSE](state, { browse }) {
    let contains = state.user.browses.content.some(brs => {
      return brs.bid === browse.bid
    })
    if (!contains) {
      state.user.browses.content.unshift(browse)
      state.user.browses.totalElements += 1
    }
  },

  [types.DELETE_USER_BROWSE](state, { browse }) {
    for (let i = 0; i < state.user.browses.content.length; i++) {
      const brs = state.user.browses.content[i]
      if (brs.bid === browse.bid) {
        state.user.browses.content.splice(i, 1)
        state.user.browses.totalElements -= 1
      }
    }
  },

  /**
   * 更新本地连接状态
   */
  [types.UPDATE_USER_CONNECTION](state, { connectionStatus }) {
    state.user.settings.connection_status = connectionStatus
  },

  /**
   * 更新网络连接状态
   */
  [types.UPDATE_NETWORK_CONNECTION](state, { connectionStatus }) {
    state.network_connection_status = connectionStatus
  },

  /**
   * 更新-是否正在拉取未读消息
   */
  [types.UPDATE_UNREAD_MESSAGE_STATUS](state, { flag }) {
    state.is_pulling_unread_message = flag
  },

  /**
   * 更新当前会话
   */
  [types.UPDATE_CURRENT_THREAD](state, { thread }) {
    // console.log('thread: ', thread)
    thread.current = true
    thread.unreadCount = 0
    // 当前会话类型
    // state.user.current_thread = thread
    state.user.current_thread = Object.assign({}, thread)
    // let uuid = ''
    // if (thread.type === constants.THREAD_TYPE_THREAD) {
    //   uuid = thread.visitor.uid
    // } else if (thread.type === constants.THREAD_TYPE_CONTACT) {
    //   uuid = thread.contact.uid
    // } else if (thread.type === constants.THREAD_TYPE_GROUP) {
    //   uuid = thread.group.gid
    // }
    // let uuid = thread.topic
    // // 从mores数组中加载
    // for (let i = 0; i < state.user.mores.length; i++) {
    //   if (state.user.mores[i].uid === uuid) {
    //     Vue.set(state.user.current_thread, 'page', state.user.mores[i].page)
    //     Vue.set(state.user.current_thread, 'first', state.user.mores[i].first)
    //     Vue.set(state.user.current_thread, 'last', state.user.mores[i].last)
    //     Vue.set(state.user.current_thread, 'totalElements', state.user.mores[i].totalElements)
    //     return
    //   }
    // }
    // // 如果上面已经匹配上的话，则不会执行到此
    // // 初始化
    // Vue.set(state.user.current_thread, 'page', 0)
    // Vue.set(state.user.current_thread, 'first', true)
    // Vue.set(state.user.current_thread, 'last', false)
    // Vue.set(state.user.current_thread, 'totalElements', 0)
    // let more = {
    //   uid: uuid,
    //   page: 0,
    //   first: true,
    //   last: false,
    //   totalElements: 0
    // }
    // state.user.mores.unshift(more)
  },

  // 持久化当前输入框草稿
  [types.PERSIST_THREAD_DRAFT](state, { topic, content }) {
    for (let i = state.user.drafts.length - 1; i >= 0; i--) {
      const element = state.user.drafts[i]
      if (element.key === topic) {
        state.user.drafts.splice(i, 1)
      }
    }
    state.user.drafts.unshift({ key: topic, value: content })
  },

  // 会话置顶
  [types.MARK_TOP_THREAD](state, { thread }) {
    //
    let contains = state.user.top_threads.some((trd) => {
      // return th.tid === thread.tid
      return trd.topic === thread.topic;
    })
    if (!contains) {
      state.user.top_threads.push(thread)
    }
    //
    if (thread.closed) {
      // 置顶之后 从历史会话中删除
      for (let i = state.history_records.content.length - 1; i >= 0; i--) {
        const element = state.history_records.content[i]
        if (element.tid === thread.tid) {
          state.history_records.content.splice(i, 1)
        }
      }
    } else {
      // 置顶之后 从进行中会话删除
      for (let i = state.user.threads.length - 1; i >= 0; i--) {
        const element = state.user.threads[i]
        if (element.tid === thread.tid) {
          state.user.threads.splice(i, 1)
        }
      }
    }
  },

  // 取消会话置顶
  [types.UNMARK_TOP_THREAD](state, { thread }) {
    //
    for (let i = state.user.top_threads.length - 1; i >= 0; i--) {
      const element = state.user.top_threads[i]
      if (element.tid === thread.tid) {
        state.user.top_threads.splice(i, 1)
      }
    }
    //
    if (thread.closed) {
      // 取消置顶之后，还回到历史会话列表
      let contains = state.history_records.content.some((th) => {
        return th.tid === thread.tid
      })
      if (!contains) {
        state.history_records.content.unshift(thread)
      }
    } else {
      // 取消置顶之后，还回到进行中会话
      let contains = state.user.threads.some((th) => {
        return th.tid === thread.tid
      })
      if (!contains) {
        state.user.threads.unshift(thread)
      }
    }
  },

  // 会话免打扰
  [types.MARK_NODISTURB_THREAD](state, { thread }) {
    //
    let contains = state.user.nodisturb_thread_topics.some(topic => {
      return topic === thread.topic
    })
    if (!contains) {
      state.user.nodisturb_thread_topics.push(thread.topic)
    }
  },

  // 取消会话免打扰
  [types.UNMARK_NODISTURB_THREAD](state, { thread }) {
    //
    for (let i = state.user.nodisturb_thread_topics.length - 1; i >= 0; i--) {
      const element = state.user.nodisturb_thread_topics[i]
      if (element === thread.topic) {
        state.user.nodisturb_thread_topics.splice(i, 1)
      }
    }
  },

  // 会话未读
  [types.MARK_UNREAD_THREAD](state, { thread }) {
    //
    let contains = state.user.unread_thread_topics.some(topic => {
      return topic === thread.topic
    })
    if (!contains) {
      state.user.unread_thread_topics.push(thread.topic)
    }
  },

  // 取消会话未读
  [types.UNMARK_UNREAD_THREAD](state, { thread }) {
    //
    for (let i = state.user.unread_thread_topics.length - 1; i >= 0; i--) {
      const element = state.user.unread_thread_topics[i]
      if (element === thread.topic) {
        state.user.unread_thread_topics.splice(i, 1)
      }
    }
  },

  // 星标/取消星标会话
  [types.MARK_STAR_THREAD](state, { thread, starType }) {
    // console.log(thread.tid, starType)
    if (starType === 0) {
      // 取消星标
      for (let i = state.user.star_threads.length - 1; i >= 0; i--) {
        const element = state.user.star_threads[i]
        if (element.tid === thread.tid) {
          state.user.star_threads.splice(i, 1)
        }
      }
      //
      if (thread.closed) {
        // 取消星标之后，还回到历史会话列表
        let contains = state.history_records.content.some((th) => {
          return th.tid === thread.tid
        })
        if (!contains) {
          state.history_records.content.unshift(thread)
        }
      } else {
        // 取消星标之后，还回到进行中会话
        let contains = state.user.threads.some((th) => {
          return th.tid === thread.tid
        })
        if (!contains) {
          state.user.threads.unshift(thread)
        }
      }
    } else {
      // 设置字段
      Vue.set(thread, 'starType', starType)
      // 设置星标
      let contains = state.user.star_threads.some((trd) => {
        return trd.topic === thread.topic;
      })
      if (!contains) {
        state.user.star_threads.push(thread)
      }
    }
    if (starType != 0) {
      if (thread.closed) {
        // 星标之后 从历史会话中删除
        for (let i = state.history_records.content.length - 1; i >= 0; i--) {
          const element = state.history_records.content[i]
          if (element.tid === thread.tid) {
            state.history_records.content.splice(i, 1)
          }
        }
      } else {
        // 星标之后 从进行中会话删除
        for (let i = state.user.threads.length - 1; i >= 0; i--) {
          const element = state.user.threads[i]
          if (element.tid === thread.tid) {
            state.user.threads.splice(i, 1)
          }
        }
      }
    }
  },

  // 更新当前会话昵称
  [types.UPDATE_CURRENT_THREAD_NICKNAME](state, { nickname }) {
    state.user.current_thread.nickname = nickname
    for (let i = 0; i < state.user.threads.length; i++) {
      const element = state.user.threads[i]
      if (element.tid === state.user.current_thread.tid) {
        state.user.threads[i].nickname = nickname
      }
    }
  },

  // 更新会话昵称
  [types.UPDATE_THREAD_NICKNAME](state, { uid, nickname }) {
    // 更新置顶会话
    for (let i = 0; i < state.user.top_threads.length; i++) {
      const element = state.user.top_threads[i]
      let elementuid = element.topic.split('/')[1] // 访客uid
      if (elementuid === uid) {
        state.user.top_threads[i].nickname = nickname
      }
    }
    // 更新星标会话
    for (let i = 0; i < state.user.star1_threads.length; i++) {
      const element = state.user.star1_threads[i]
      let elementuid = element.topic.split('/')[1] // 访客uid
      if (elementuid === uid) {
        state.user.star1_threads[i].nickname = nickname
      }
    }
    for (let i = 0; i < state.user.star2_threads.length; i++) {
      const element = state.user.star2_threads[i]
      let elementuid = element.topic.split('/')[1] // 访客uid
      if (elementuid === uid) {
        state.user.star2_threads[i].nickname = nickname
      }
    }
    for (let i = 0; i < state.user.star3_threads.length; i++) {
      const element = state.user.star3_threads[i]
      let elementuid = element.topic.split('/')[1] // 访客uid
      if (elementuid === uid) {
        state.user.star3_threads[i].nickname = nickname
      }
    }
    for (let i = 0; i < state.user.star4_threads.length; i++) {
      const element = state.user.star4_threads[i]
      let elementuid = element.topic.split('/')[1] // 访客uid
      if (elementuid === uid) {
        state.user.star4_threads[i].nickname = nickname
      }
    }
    // 更新当前会话
    for (let i = 0; i < state.user.threads.length; i++) {
      const element = state.user.threads[i]
      let elementuid = element.topic.split('/')[1] // 访客uid
      if (elementuid === uid) {
        state.user.threads[i].nickname = nickname
      }
    }
    // 更新历史会话
    for (let i = 0; i < state.history_records.content.length; i++) {
      const element = state.history_records.content[i]
      let elementuid = element.topic.split('/')[1] // 访客uid
      if (elementuid === uid) {
        state.history_records.content[i].nickname = nickname
      }
    }
    // 设置备注
    state.user.note_map.set(uid, nickname)
  },

  [types.CLEAR_CURRENT_THREAD](state) {
    state.user.current_thread.id = 0
  },

  // 更新会话未读消息数
  [types.UPDATE_THREAD_UNREAD_COUNT](state, { tid, unreadCount }) {
    for (let i = state.user.threads.length - 1; i >= 0; i--) {
      // console.log('remove:', state.user.threads[i].tid, tid)
      if (state.user.threads[i].tid === tid) {
        state.user.threads[i].unreadCount = unreadCount
      }
    }
  },

  // 设置当前queue
  [types.UPDATE_CURRENT_QUEUE](state, { queue }) {
    state.user.current_queue = queue
  },

  [types.UPDATE_CURRENT_BROWSE](state, { browse }) {
    state.user.current_browse = browse
  },

  [types.UPDATE_CURRENT_CUSTOMER_INFO](state, { crm }) {
    // state.user.current_crm.tags = crm.tags
    state.user.current_crm = crm
  },

  [types.CLEAR_CURRENT_CUSTOMER_INFO](state) {
    //
    state.user.current_crm = {
      id: 0,
      cid: '',
      name: '',
      email: '',
      mobile: '',
      age: 0,
      job: '',
      company: '',
      description: '',
      tid: '',
      tags: [],
      uid: ''
    }
  },

  [types.ADD_CUSTOMER_INFO](state, { crm }) {
    let contains = false
    for (let i = state.user.crms.length - 1; i > 0; i--) {
      const element = state.user.crms[i]
      if (element.cid === crm.cid) {
        contains = true
        state.user.crms[i].tags = element.tags
        state.user.crms[i] = element
        // state.user.crms.splice(i, 1)
        // state.user.crms.push(element)
      }
    }
    if (!contains) {
      state.user.crms.push(crm)
    }
  },

  // 客户管理
  [types.PERSIST_CUSTOMERS](state, { customers }) {
    //
    state.user.customers = customers
  },

  [types.PERSIST_NOTICE_BROWSES](state, { browse }) {
    //
    let contains = false
    for (let i = 0; i < state.user.notice_browses.length; i++) {
      const element = state.user.notice_browses[i]
      if (element.user.uid === browse.user.uid) {
        contains = true
        state.user.notice_browses[i].timestamp = browse.timestamp
      }
    }
    if (!contains) {
      state.user.notice_browses.push(browse)
    }
  },

  [types.UPDATE_CURRENT_NOTICE_BROWSES](state, { browse }) {
    //
    state.user.current_notice_browse = browse
  },

  // 通知
  [types.ADD_NOTICE](state, { notice }) {
    //
    state.user.notices.unshift(notice)
  },

  [types.CLEAR_NOTICES](state) {
    //
    state.user.notices = []
  },

  [types.PERSIST_NOTICES](state, { notices }) {
    //
    state.user.notices = notices
  },

  [types.UPDATE_CURRENT_NOTICE](state, { notice }) {
    //
    state.user.current_notice = notice
  },

  // 待办任务
  [types.ADD_TODO](state, { todo }) {
    //
    state.user.todos.unshift(todo)
  },

  [types.CLEAR_TODOS](state) {
    //
    state.user.todos = []
  },

  [types.PERSIST_TODOS](state, { todos }) {
    //
    state.user.todos = todos
  },

  [types.UPDATE_CURRENT_TODO](state, { todo }) {
    //
    state.user.current_todo = todo
  },

  [types.UPDATE_TODO](state, { todo }) {
    //
    for (let i = 0; i < state.user.todos.length; i++) {
      const element = state.user.todos[i]
      if (element.id === id) {
        state.user.todos[i] = todo
      }
    }
  },

  // 删除待办任务
  [types.DELETE_TODO](state, { id }) {
    //
    for (let i = 0; i < state.user.todos.length; i++) {
      const element = state.user.todos[i]
      if (element.id === id) {
        state.user.todos.splice(i)
      }
    }
    state.user.current_todo = {
      tid: '',
      title: '',
      content: '',
      type: '',
      attachments: [],
      createdAt: ''
    }
  },

  /**
   * 持久化管理员会话
   */
  // [types.PERSIST_THREADS] (state, { threads }) {
  //   state.threads = threads
  // },

  [types.PERSIST_HISTORIES](state, { histories }) {
    state.histories = histories
  },

  [types.CLEAR_HISTORY_RECORDS](state) {
    state.history_records.content = []; //
  },

  [types.PERSIST_HISTORY_RECORDS](state, { history_records }) {
    state.history_records = history_records
    //
    // for (let index = 0; index < history_records.content.length; index++) {
    //   const element = history_records.content[index]
    //   state.history_records.content.push(element)
    // }
    //
    // state.history_records.empty = history_records.empty
    // state.history_records.first = history_records.first
    // state.history_records.last = history_records.last
    // state.history_records.number = history_records.number
    // state.history_records.numberOfElements = history_records.numberOfElements
    // state.history_records.size = history_records.size
    // state.history_records.totalElements = history_records.totalElements
    // state.history_records.totalPages = history_records.totalPages
  },

  [types.PERSIST_SEARCH_THREADS](state, { history_records }) {
    //
    for (let i = 0; i < history_records.length; i++) {
      const thread = history_records[i];
      //
      let contains = false;
      for (let j = 0; j < state.history_records.length; j++) {
        const element = state.history_records[j];
        if (element.tid === thread.tid) {
          contains = true;
        }
      }
      //
      if (!contains) {
        state.history_records.content.push(thread)
      }
    }
  },

  [types.PERSIST_SEARCH_THREAD](state, { thread }) {
    let contains = false
    for (let i = 0; i < state.history_records.length; i++) {
      const element = state.history_records[i]
      if (element.tid === thread.tid) {
        contains = true
      }
    }
    if (!contains) {
      state.history_records.content.push(thread)
    }
  },

  [types.PERSIST_RATES](state, { rates }) {
    state.rates = rates
  },

  [types.PERSIST_MESSAGES_ARCHIVE](state, { messagesArchive }) {
    state.messagesArchive = messagesArchive
  },

  [types.PERSIST_MESSAGES](state, { messages }) {
    state.messages = messages
  },

  [types.PERSIST_STATUSES](state, { statuses }) {
    state.statuses = statuses
  },

  [types.PERSIST_QUEUES](state, { queues }) {
    state.queues = queues
  },

  [types.PERSIST_BROWSES](state, { browses }) {
    state.browses = browses
  },

  // 服务器查询结果包含一对一和群组会话，此处过滤掉，仅包含客服会话
  [types.PERSIST_MONITORS](state, { monitors }) {
    // state.user.monitor_threads = monitors
    state.user.monitor_threads = []
    for (let i = 0; i < monitors.length; i++) {
      const element = monitors[i]
      if (element.type === constants.THREAD_TYPE_WORKGROUP || element.type === constants.THREAD_TYPE_APPOINTED) {
        state.user.monitor_threads.push(element)
      }
    }
  },

  [types.REMOVE_MONITORS](state, { tid }) {
    for (let i = state.user.monitor_threads.length - 1; i >= 0; i--) {
      const thread = state.user.monitor_threads[i]
      if (thread.tid === tid) {
        state.user.monitor_threads.splice(i, 1)
      }
    }
  },

  [types.PERSIST_QUALITIES](state, { qualities }) {
    state.qualities = qualities
  },

  /**
   * 快捷回复
   * Vue.delete(this.items, index)
   */
  [types.PERSIST_CUWS](state, { cuws }) {
    // console.log('cuws', cuws)
    // for (let i = 0; i < cuws.mine.length; i++) {
    //   const element = cuws.mine[i]
    //   for (let j = 0; j < element.cuwChildren.length; j++) {
    //     const cuw = element.cuwChildren[j]
    //     if (cuw.cuwChildren.length == 0) {
    //       Vue.delete(cuws.mine[i].cuwChildren[j], 'cuwChildren')
    //     }
    //   }
    // }
    state.cuws[0].cuwChildren = cuws.mine
    state.cuws[1].cuwChildren = cuws.company
    state.cuws[2].cuwChildren = cuws.platform
  },

  [types.ADD_CUW](state, { cuw, category }) {
    if (cuw === null) {
      state.cuws[0].cuwChildren.unshift(category)
    } else {
      // let index = (category.type === constants.CATEGORY_TYPE_CUW_MINE) ? 0 : 1
      for (let i = 0; i < state.cuws[0].cuwChildren.length; i++) {
        const cate = state.cuws[0].cuwChildren[i]
        if (category.id === cate.id) {
          state.cuws[0].cuwChildren[i].cuwChildren.unshift(cuw)
          return
        }
      }
    }
  },

  [types.UPDATE_CUW](state, { cuw, category }) {
    if (cuw === null) {
      for (let i = 0; i < state.cuws[0].cuwChildren.length; i++) {
        if (state.cuws[0].cuwChildren[i].id === category.id) {
          Vue.set(state.cuws[0].cuwChildren[i], 'name', category.name)
        }
      }
    } else {
      // let index = (category.type === constants.CATEGORY_TYPE_CUW_MINE) ? 0 : 1
      for (let i = 0; i < state.cuws[0].cuwChildren.length; i++) {
        let cate = state.cuws[0].cuwChildren[i]
        for (let j = 0; j < cate.cuwChildren.length; j++) {
          if (cate.cuwChildren[j].id === cuw.id) {
            Vue.set(cate.cuwChildren[j], 'name', cuw.name)
            Vue.set(cate.cuwChildren[j], 'content', cuw.content)
            Vue.set(cate.cuwChildren[j], 'shortcut', cuw.shortcut)
          }
        }
      }
    }
  },

  [types.DELETE_CUW](state, { cuwId, categoryId }) {
    if (cuwId === null) {
      for (let i = 0; i < state.cuws[0].cuwChildren.length; i++) {
        const cate = state.cuws[0].cuwChildren[i]
        if (cate.id === categoryId) {
          state.cuws[0].cuwChildren.splice(i, 1)
        }
      }
    } else {
      // let index = (category.type === constants.CATEGORY_TYPE_CUW_MINE) ? 0 : 1
      for (let i = 0; i < state.cuws[0].cuwChildren.length; i++) {
        let cate = state.cuws[0].cuwChildren[i]
        for (let j = 0; j < cate.cuwChildren.length; j++) {
          const cu = cate.cuwChildren[j]
          if (cu.id === cuwId) {
            cate.cuwChildren.splice(j, 1)
          }
        }
      }
    }
  },

  [types.UPDATE_COMPANY_CURRENT_CUW_CATEGORY_ID](state, { categoryId }) {
    state.current_company_cuw_category_id = categoryId
  },

  /**
   * 设备指纹信息
   */
  [types.PERSIST_USER_FINGERPRINTS](state, { fingerPrints }) {
    state.user.fingerPrints = fingerPrints
  },

  [types.ADD_USER_FINGERPRINT](state, { fingerPrint }) {
    state.user.fingerPrints.push(fingerPrint)
  },

  /**
   * 当前访客信息
   */
  [types.PERSIST_VISITOR_PROFILE](state, { info }) {
    state.user.current_visitor_info = info
  },

  /**
   * 所有客服账号
   */
  [types.PERSIST_AGENTS](state, { agents }) {
    state.agents = agents
  },

  [types.PERSIST_ONLINE_AGENTS](state, { agents }) {
    state.online_agents = agents
  },

  [types.PERSIST_VISITOR_UNIAPP](state, { visitors }) {
    state.visitors_uniapp = visitors
  },

  [types.PERSIST_VISITOR_FLUTTER](state, { visitors }) {
    state.visitors_flutter = visitors
  },

  [types.PERSIST_VISITOR_ANDROID](state, { visitors }) {
    state.visitors_android = visitors
  },

  [types.PERSIST_VISITOR_IOS](state, { visitors }) {
    state.visitors_ios = visitors
  },

  [types.PERSIST_VISITOR_WECHAT](state, { visitors }) {
    state.visitors_wechat = visitors
  },

  // /**
  //  * 创建新客服账号
  //  */
  // [types.ADD_AGENT](state, { agent }) {
  //   let contains = state.agents.content.some(agt => {
  //     return agt.id === agent.id
  //   })
  //   if (!contains) {
  //     state.agents.content.unshift(agent)
  //   }
  // },

  // /**
  //  * 更新客服账号
  //  */
  // [types.UPDATE_AGENT](state, { agent }) {
  //   for (let i = state.agents.content.length - 1; i >= 0; i--) {
  //     const agt = state.agents.content[i]
  //     if (agt.id === agent.id) {
  //       state.agents.content.splice(i, 1)
  //       state.agents.content.unshift(agent)
  //     }
  //   }
  // },

  // /**
  //  * 本地删除
  //  */
  // [types.DELETE_AGENT](state, { id }) {
  //   for (let i = state.agents.content.length - 1; i >= 0; i--) {
  //     const agent = state.agents.content[i]
  //     if (agent.id === id) {
  //       state.agents.content.splice(i, 1)
  //     }
  //   }
  // },

  // /**
  //  * 持久化管理员工作组
  //  */
  // [types.PERSIST_WORKGROUPS](state, { workGroups }) {
  //   state.workGroups = workGroups
  // },

  // /**
  //  * 添加工作组
  //  */
  // [types.ADD_WORKGROUP](state, { workGroup }) {
  //   let contains = state.workGroups.content.some(wg => {
  //     return wg.id === workGroup.id
  //   })
  //   if (!contains) {
  //     state.workGroups.content.unshift(workGroup)
  //   }
  // },

  // /**
  //  * 更新工作组
  //  */
  // [types.UPDATE_WORKGROUP](state, { workGroup }) {
  //   for (let i = state.workGroups.content.length - 1; i >= 0; i--) {
  //     const wg = state.workGroups.content[i]
  //     if (wg.id === workGroup.id) {
  //       state.workGroups.content.splice(i, 1, workGroup)
  //       // state.workGroups.content.unshift(workGroup)
  //     }
  //   }
  // },

  // /**
  //  * 删除工作组
  //  */
  // [types.DELETE_WORKGROUP](state, { id }) {
  //   for (let i = state.workGroups.content.length - 1; i >= 0; i--) {
  //     const wg = state.workGroups.content[i]
  //     if (wg.id === id) {
  //       state.workGroups.content.splice(i, 1)
  //     }
  //   }
  // },

  /**
   * 省市
   */
  [types.PERSIST_REGIONS](state, { regions }) {
    state.regions = regions
  },

  /**
   * 持久化分公司
   */
  [types.PERSIST_COMPANIES](state, { companies }) {
    state.companies = companies
  },

  [types.ADD_COMPANY](state, { company }) {
    let contains = state.companies.content.some(comp => {
      return comp.id === company.id
    })
    if (!contains) {
      state.companies.content.unshift(company)
    }
  },

  [types.UPDATE_COMPANY](state, { company }) {
    for (let i = state.companies.content.length - 1; i >= 0; i--) {
      const comp = state.companies.content[i]
      if (comp.id === company.id) {
        state.companies.content.splice(i, 1, company)
        // state.companies.content.unshift(company)
      }
    }
  },

  [types.DELETE_COMPANY](state, { cid }) {
    for (let i = state.companies.content.length - 1; i >= 0; i--) {
      const comp = state.companies.content[i]
      if (comp.cid === cid) {
        state.companies.content.splice(i, 1)
      }
    }
  },

  /**
   * 持久化用户标签
   */
  // [types.PERSIST_USER_TAGS] (state, { uid, tags }) {
  //   // state.user.userTags[uid] = tags
  // },

  [types.PERSIST_USER_TAGS](state, { tags }) {
    state.user.userTags = tags
  },

  [types.PERSIST_THREAD_TAGS](state, { tags }) {
    state.user.threadTags = tags
  },

  /**
   * 添加用户标签
   */
  [types.ADD_USER_TAG](state, { tag }) {
    let contains = state.user.userTags.some(tg => {
      return tg.id === tag.id
    })
    if (!contains) {
      state.user.userTags.unshift(tag)
    }
  },

  /**
   * 删除用户标签
   */
  [types.DELETE_USER_TAG](state, { id }) {
    for (let index = 0; index < state.user.userTags.length; index++) {
      const tag = state.user.userTags[index]
      if (tag.id === id) {
        state.user.userTags.splice(index, 1)
      }
    }
  },

  /**
   * 类别：robot/support/cuw
   */
  [types.PERSIST_CATEGORIES](state, { categories }) {
    state.categories = categories
  },

  [types.ADD_CATEGORY](state, { category }) {
    let contains = state.categories.some(cate => {
      return cate.id === category.id
    })
    if (!contains) {
      state.categories.unshift(category)
      state.cuws[1].cuwChildren.unshift(category)
    }
  },

  [types.UPDATE_CATEGORY](state, { category }) {
    // console.log('update')
    for (let i = state.categories.length - 1; i >= 0; i--) {
      const cate = state.categories[i]
      if (cate.id === category.id) {
        console.log('update category:', category)
        //
        Vue.set(state.categories[i], 'name', category.name)
        // state.categories.splice(i, 1)
        // state.categories.unshift(category)
      }
    }
  },

  [types.DELETE_CATEGORY](state, { id }) {
    for (let i = state.categories.length - 1; i >= 0; i--) {
      const category = state.categories[i]
      if (category.id === id) {
        state.categories.splice(i, 1)
      }
    }
  },

  /**
   * 持久化智能问答
   */
  [types.PERSIST_ROBOT_ANSWERS](state, { answers }) {
    state.robot.answers = answers
  },

  /**
   * 添加智能问答
   */
  [types.ADD_ROBOT_ANSWER](state, { answer }) {
    let contains = state.robot.answers.content.some(ans => {
      return ans.id === answer.id
    })
    if (!contains) {
      state.robot.answers.content.unshift(answer)
    }
  },

  /**
   * 更新智能问答
   */
  [types.UPDATE_ROBOT_ANSWER](state, { answer }) {
    for (let i = state.robot.answers.content.length - 1; i >= 0; i--) {
      const ans = state.robot.answers.content[i]
      if (ans.id === answer.id) {
        state.robot.answers.content.splice(i, 1, answer)
        // state.robot.answers.content.unshift(answer)
      }
    }
  },

  /**
   * 删除智能问答
   */
  [types.DELETE_ROBOT_ANSWER](state, { aid }) {
    for (let i = 0; i < state.robot.answers.content.length; i++) {
      const answer = state.robot.answers.content[i]
      if (answer.aid === aid) {
        state.robot.answers.content.splice(i, 1)
      }
    }
  },

  /**
   * 持久化相似词
   */
  [types.PERSIST_ROBOT_SYNONYMS](state, { synonyms }) {
    state.robot.synonyms = synonyms
  },

  /**
   * 添加相似词
   */
  [types.ADD_ROBOT_SYNONYM](state, { synonym }) {
    let contains = state.robot.synonyms.content.some(syn => {
      return syn.sid === synonym.sid
    })
    if (!contains) {
      state.robot.synonyms.content.unshift(synonym)
    }
  },

  /**
   * 更新相似词
   */
  [types.UPDATE_ROBOT_SYNONYM](state, { synonym }) {
    for (let i = state.robot.synonyms.content.length - 1; i >= 0; i--) {
      const syn = state.robot.synonyms.content[i]
      if (syn.sid === synonym.sid) {
        state.robot.synonyms.content.splice(i, 1, synonym)
        // state.robot.synonyms.content.unshift(synonym)
      }
    }
  },

  /**
   * 删除相似词
   */
  [types.DELETE_ROBOT_SYNONYM](state, { sid }) {
    for (let i = 0; i < state.robot.synonyms.content.length; i++) {
      const synonym = state.robot.synonyms.content[i]
      if (synonym.sid === sid) {
        state.robot.synonyms.content.splice(i, 1)
      }
    }
  },

  /**
   * 持久化敏感词
   */
  [types.PERSIST_TABOOS](state, { taboos }) {
    state.taboos = taboos
  },

  /**
   * 添加敏感词
   */
  // [types.ADD_TABOO] (state, { taboo }) {
  //   let contains = state.taboos.content.some(syn => {
  //     return syn.sid === taboo.tid
  //   })
  //   if (!contains) {
  //     state.taboos.content.unshift(taboo)
  //   }
  // },

  /**
   * 更新敏感词
   */
  // [types.UPDATE_TABOO] (state, { taboo }) {
  //   for (let i = state.taboos.content.length - 1; i >= 0; i--) {
  //     const syn = state.taboos.content[i]
  //     if (syn.tid === taboo.tid) {
  //       state.taboos.content.splice(i, 1, taboo)
  //       // state.taboos.content.unshift(taboo)
  //     }
  //   }
  // },

  /**
   * 删除敏感词
   */
  // [types.DELETE_TABOO] (state, { tid }) {
  //   for (let i = 0; i < state.taboos.content.length; i++) {
  //     const taboo = state.taboos.content[i]
  //     if (taboo.tid === tid) {
  //       state.taboos.content.splice(i, 1)
  //     }
  //   }
  // },

  /**
   * 持久化所有工作组，用于历史会话过滤
   */
  [types.PERSIST_FILTER_WORKGROUPS](state, { workGroups }) {
    state.filter.workGroups = workGroups
  },

  /**
   * 持久化所有工作组成员，用于历史会话过滤
   */
  [types.PERSIST_FILTER_WORKGROUP_MEMBERS](state, { workGroupMembers }) {
    state.filter.workGroupMembers = workGroupMembers
  },

  /**
   * 持久化留言
   */
  [types.PERSIST_LEAVE_MESSAGES](state, { leaveMessages }) {
    state.leaveMessages = leaveMessages
  },

  /**
   * 更新留言
   */
  [types.UPDATE_LEAVE_MESSAGE](state, { leaveMessage }) {
    // console.log('update:', leaveMessage)
    for (let i = state.leaveMessages.content.length - 1; i >= 0; i--) {
      const leave = state.leaveMessages.content[i]
      if (leave.id === leaveMessage.id) {
        state.leaveMessages.content.splice(i, 1, leaveMessage)
        // state.leaveMessages.content.unshift(leaveMessage)
      }
    }
  },

  /**
   * 删除留言
   */
  [types.DELETE_LEAVE_MESSAGE](state, { id }) {
    for (let i = 0; i < state.leaveMessages.length; i++) {
      const leave = state.leaveMessages[i]
      if (leave.id === id) {
        state.leaveMessages.content.splice(i, 1)
      }
    }
  },

  [types.PERSIST_SUPPORT_ARTICLES](state, { articles }) {
    state.support.articles = articles
  },

  [types.ADD_SUPPORT_ARTICLE](state, { article }) {
    let contains = state.support.articles.content.some(cate => {
      return cate.id === article.id
    })
    if (!contains) {
      state.support.articles.content.unshift(article)
    }
  },

  [types.UPDATE_SUPPORT_ARTICLE](state, { article }) {
    for (let i = state.support.articles.content.length - 1; i >= 0; i--) {
      const articleElement = state.support.articles.content[i]
      if (articleElement.id === article.id) {
        state.support.articles.content.splice(i, 1, article)
        // state.support.articles.content.unshift(article)
      }
    }
  },

  [types.DELETE_SUPPORT_ARTICLE](state, { articleId }) {
    for (let i = state.support.articles.content.length - 1; i >= 0; i--) {
      const tag = state.support.articles.content[i]
      if (tag.id === articleId) {
        state.support.articles.content.splice(i, 1)
      }
    }
  },

  /**
   * 持久化统计数据
   */
  [types.PERSIST_STATISTICS](state, { statistic }) {
    state.statistic.online_agent_count = statistic.onlineAgentCount
    state.statistic.current_thread_count = statistic.currentThreadCount
    state.statistic.current_queue_count = statistic.currentQueueCount
    state.statistic.today_total_thread_count = statistic.todayTotalThreadCount
    state.statistic.today_total_queue_count = statistic.todayTotalQueueCount
    state.statistic.today_leave_queue_count = statistic.todayLeaveQueueCount
    state.statistic.statistic_list = statistic.statisticList
    state.statistic.statistic_detail_list = statistic.statisticDetailList
  },

  // 当前客服实时统计数据
  [types.PERSIST_STATISTICS_AGENT_TODAY](state, { statistic }) {
    state.statistics_agent_today.threadCount = statistic.threadCount
    state.statistics_agent_today.lt30sRate = statistic.lt30sRate
    state.statistics_agent_today.satisfyRate = statistic.satisfyRate
    state.statistics_agent_today.averageResponseLength = statistic.averageResponseLength
    state.statistics_agent_today.responseLt3mRate = statistic.responseLt3mRate
    state.statistics_agent_today.agentMessageCount = statistic.agentMessageCount
    state.statistics_agent_today.agentWordCount = statistic.agentWordCount
    state.statistics_agent_today.visitorMessageCount = statistic.visitorMessageCount
    state.statistics_agent_today.visitorWordCount = statistic.visitorWordCount
  },

  // 根据客服uid获取实时统计数据
  [types.PERSIST_STATISTICS_AGENT_UID_TODAY](state, { uid, statistic }) {
    let contains = false
    for (let i = 0; i < state.statistics_agent_today_uids.length; i++) {
      const element = state.statistics_agent_today_uids[i]
      if (element.uid === uid) {
        contains = true
      }
    }
    if (!contains) {
      let statistics_agent_today = {
        uid: uid,
        threadCount: statistic.threadCount, // 接待人次
        lt30sRate: statistic.lt30sRate, // 30秒应答率
        satisfyRate: statistic.satisfyRate, // 评价满意率
        averageResponseLength: statistic.averageResponseLength, // 平均人工响应时长
        responseLt3mRate: statistic.responseLt3mRate, // 3分钟人工回复率
        agentMessageCount: statistic.agentMessageCount, // 发送消息数
        agentWordCount: statistic.agentWordCount, // 发送消息字数
        visitorMessageCount: statistic.visitorMessageCount, // 接收消息数
        visitorWordCount: statistic.visitorWordCount, // 接收消息字数
      }
      state.statistics_agent_today_uids.push(statistics_agent_today)
    }
  },

  [types.PERSIST_STATISTIC_DETAILS](state, { detail }) {
    state.statistic.statistic_detail_list = detail
  },

  [types.PERSIST_STATISTICS_THREADS](state, { threads }) {
    state.statistic.threads = threads
  },

  [types.PERSIST_STATISTICS_RATES](state, { rates }) {
    state.statistic.rates = rates
  },

  /**
   * 持久化角色
   */
  [types.PERSIST_ROLES](state, { roles }) {
    state.roles = roles
  },

  /**
   * 持久化webs
   */
  [types.PERSIST_WEBS](state, { webs }) {
    state.webs = webs
  },

  [types.ADD_WEB](state, { web }) {
    let contains = state.webs.content.some(wb => {
      return wb.id === web.id
    })
    if (!contains) {
      state.webs.content.unshift(web)
    }
  },

  [types.UPDATE_WEB](state, { web }) {
    for (let i = state.webs.content.length - 1; i >= 0; i--) {
      const wb = state.webs.content[i]
      if (wb.id === web.id) {
        state.webs.content.splice(i, 1, web)
        // state.webs.content.unshift(web)
      }
    }
  },

  [types.DELETE_WEB](state, { aid }) {
    for (let i = state.webs.content.length - 1; i >= 0; i--) {
      const wb = state.webs.content[i]
      if (wb.aid === aid) {
        state.webs.content.splice(i, 1)
      }
    }
  },

  [types.PERSIST_APPS](state, { apps }) {
    state.apps = apps
  },

  [types.ADD_APP](state, { app }) {
    let contains = state.apps.content.some(ap => {
      return ap.id === app.id
    })
    if (!contains) {
      state.apps.content.unshift(app)
    }
  },

  [types.UPDATE_APP](state, { app }) {
    for (let i = state.apps.content.length - 1; i >= 0; i--) {
      const wb = state.apps.content[i]
      if (wb.id === app.id) {
        state.apps.content.splice(i, 1, app)
        // state.apps.content.unshift(app)
      }
    }
  },

  [types.DELETE_APP](state, { aid }) {
    for (let i = state.apps.content.length - 1; i >= 0; i--) {
      const wb = state.apps.content[i]
      if (wb.aid === aid) {
        state.apps.content.splice(i, 1)
      }
    }
  },

  [types.PERSIST_MPS](state, { mps }) {
    state.mps = mps
  },

  [types.ADD_MP](state, { mp }) {
    let contains = state.mps.content.some(m => {
      return m.id === mp.id
    })
    if (!contains) {
      state.mps.content.unshift(mp)
    }
  },

  [types.UPDATE_MP](state, { mp }) {
    for (let i = state.mps.content.length - 1; i >= 0; i--) {
      const wb = state.mps.content[i]
      if (wb.id === mp.id) {
        state.mps.content.splice(i, 1, mp)
        // state.mps.content.unshift(mp)
      }
    }
  },

  [types.DELETE_MP](state, { wid }) {
    for (let i = state.mps.content.length - 1; i >= 0; i--) {
      const wb = state.mps.content[i]
      if (wb.wid === wid) {
        state.mps.content.splice(i, 1)
      }
    }
  },

  [types.PERSIST_MINIS](state, { minis }) {
    state.minis = minis
  },

  [types.ADD_MINI](state, { mini }) {
    let contains = state.minis.content.some(mi => {
      return mi.id === mini.id
    })
    if (!contains) {
      state.minis.content.unshift(mini)
    }
  },

  [types.UPDATE_MINI](state, { mini }) {
    for (let i = state.minis.content.length - 1; i >= 0; i--) {
      const wb = state.minis.content[i]
      if (wb.id === mini.id) {
        state.minis.content.splice(i, 1, mini)
        // state.minis.content.unshift(mini)
      }
    }
  },

  [types.DELETE_MINI](state, { wid }) {
    for (let i = state.minis.content.length - 1; i >= 0; i--) {
      const wb = state.minis.content[i]
      if (wb.wid === wid) {
        state.minis.content.splice(i, 1)
      }
    }
  },

  
  /**
   * 添加订阅
   */
  [types.SUBSCRIBE_TOPIC](state, { topic, subscription }) {
    let contains = state.user.subscribed_topics.some(object => {
      return topic === object.topic
    })
    if (!contains) {
      let object = { 'topic': topic, 'subscription': subscription }
      state.user.subscribed_topics.push(object)
    }
  },

  /**
   * 取消订阅
   */
  [types.UNSUBSCRIBE_TOPIC](state, { topic }) {
    for (let i = state.user.subscribed_topics.length - 1; i >= 0; i--) {
      const object = state.user.subscribed_topics[i]
      if (object.topic === topic) {
        state.user.subscribed_topics.splice(i, 1)
      }
    }
  },

  /**
   * 清空订阅
   */
  [types.CLEAR_TOPIC](state) {
    state.user.subscribed_topics = []
  },

  /**
   * 修改当前主view
   */
  [types.CHANGE_CURRENT_MAIN_VIEW](state, { view }) {
    state.current_main_view = view
  },

  /**
   * 修改边栏颜色
   */
  [types.CHANGE_SIDEBAR_COLOR](state, { color }) {
    state.user.settings.sidebarColor = color
  },

  /**
   * 添加工单
   */
  [types.ADD_TICKET](state, { ticket }) {
    //
    let contains = state.user.tickets.some(tk => {
      return tk.tid === ticket.tid
    })
    if (!contains) {
      state.user.tickets.unshift(ticket)
    }
  },

  [types.ADD_FOR_ME_TO_REPLY_TICKET](state, { tickets }) {
    state.user.formereply_tickets = tickets
  },

  [types.ADD_TO_BE_REPLIED_TICKET](state, { tickets }) {
    state.user.tobereplied_tickets = tickets
  },

  [types.ADD_DONE_TICKET](state, { tickets }) {
    state.user.done_tickets = tickets
  },

  [types.ADD_IGNORED_TICKET](state, { tickets }) {
    state.user.ignored_tickets = tickets
  },

  [types.ADD_CLOSED_TICKET](state, { tickets }) {
    state.user.closed_tickets = tickets
  },

  [types.DO_IGNORE_TICKET](state, { tid }) {
    //
    let contains = false
    for (let i = state.user.formereply_tickets.content.length - 1; i >= 0; i--) {
      let ticket = state.user.formereply_tickets.content[i]
      ticket.closed = true
      if (ticket.tid === tid) {
        contains = true
        state.user.formereply_tickets.content.splice(i, 1)
        state.user.ignored_tickets.content.unshift(ticket)
      }
    }
    //
    if (!contains) {
      for (let i = state.user.tobereplied_tickets.content.length - 1; i >= 0; i--) {
        let ticket = state.user.tobereplied_tickets.content[i]
        ticket.closed = true
        if (ticket.tid === tid) {
          state.user.tobereplied_tickets.content.splice(i, 1)
          state.user.ignored_tickets.content.unshift(ticket)
        }
      }
    }
  },

  [types.DO_DONE_TICKET](state, { tid }) {
    //
    let contains = false
    for (let i = state.user.formereply_tickets.content.length - 1; i >= 0; i--) {
      let ticket = state.user.formereply_tickets.content[i]
      ticket.closed = true
      if (ticket.tid === tid) {
        contains = true
        state.user.formereply_tickets.content.splice(i, 1)
        state.user.done_tickets.content.unshift(ticket)
      }
    }
    //
    if (!contains) {
      for (let i = state.user.tobereplied_tickets.content.length - 1; i >= 0; i--) {
        let ticket = state.user.tobereplied_tickets.content[i]
        ticket.closed = true
        if (ticket.tid === tid) {
          state.user.tobereplied_tickets.content.splice(i, 1)
          state.user.done_tickets.content.unshift(ticket)
        }
      }
    }
  },

  /**
   * 删除工单
   */
  [types.REMOVE_TICKET](state, { tid }) {
    //
    for (let i = 0; i < state.user.tickets.length; i++) {
      const ticket = state.user.tickets[i]
      if (ticket.tid === tid) {
        state.user.tickets.splice(i, 1)
      }
    }
  },

  /**
   * 清空工单
   */
  [types.CLEAR_TICKETS](state) {
    //
    state.user.tickets = []
  },

  /**
   * 更新工单
   */
  [types.UPDATE_TICKET](state, { ticket }) {
    //
    // state.user.current_ticket = ticket
  },

  // 设置当前工单
  [types.UPDATE_CURRENT_TICKET](state, { ticket }) {
    //
    state.user.current_ticket = ticket
  },

  // 设置当前在线访客
  [types.UPDATE_CURRENT_ONLINE_USER](state, { user }) {
    //
    state.user.current_online_user = user
  },

  // 持久化在线访客
  [types.PERSIST_ONLINE_USERS](state, { onlineUsers }) {
    //
    state.user.onlineUsers = onlineUsers
  },

  // 设置当前监控会话
  [types.UPDATE_CURRENT_MONITOR_THREAD](state, { thread }) {
    //
    state.user.current_monitor_thread = thread
  },

  // 设置是否显示底部统计数据
  [types.UPDATE_SHOW_BOTTOM_STATISTICS](state, { show }) {
    //
    state.show_bottom_statistics = show
  },

  // 设置是否显示超时提醒
  [types.UPDATE_SHOW_OUT_OF_TIME](state, { show }) {
    //
    state.show_out_of_time = show
  },

  // 设置是否显示输入联想
  [types.UPDATE_SHOW_INPUT_TIPS](state, { show }) {
    //
    state.show_input_tip = show
  },

  // 设置是否检测是否绑定公众号
  [types.UPDATE_QUERY_MPQRCODE_URL](state, { show }) {
    //
    state.query_mpqrcode_url = show
  },

  // 设置视频客服状态
  [types.UPDATE_WEBRTC_STARTED](state, { show }) {
    //
    state.is_webrtc_started = show
  },

  // 持久化黑名单
  [types.PERSIST_BLOCKS](state, { blocks }) {
    state.user.blocks = blocks
  },

  // 更新当前黑名单哦用户
  [types.UPDATE_CURRENT_BLOCK](state, { block }) {
    state.user.current_block = block
  },

  // 取消拉黑当前用户
  [types.REMOVE_CURRENT_BLOCK](state, { bid }) {
    for (let i = 0; i < state.user.blocks.content.length; i++) {
      const element = state.user.blocks.content[i]
      if (element.bid === bid) {
        state.user.blocks.content.splice(i, 1)
        state.user.current_block.bid = ''
        state.user.current_block.blockedUser.uid = ''
      }
    }
  },

  // 持久化会话小结
  [types.PERSIST_SUMMARIES](state, { summaries }) {
    state.user.summaries = summaries
  },

  // 持久化意见反馈
  [types.PERSIST_FEEDBACKS](state, { feedbacks }) {
    state.user.feedbacks = feedbacks
  },

  // 持久化意见反馈
  [types.PERSIST_STATUSES](state, { statuses }) {
    state.user.statuses = statuses
  },

  // 持久化表情
  [types.PERSIST_SELF_EMOJIS](state, { emojis }) {
    state.user.selfEmojis = emojis
  },

  // 添加表情
  [types.ADD_SELF_EMOJIS](state, { emoji }) {
    state.user.selfEmojis.content.unshift(emoji)
  },

  // 更新表情
  // [types.UPDATE_SELF_EMOJIS](state, { emoji }) {
  //   // state.user.selfEmojis.content.unshift(emoji)
  //   for (let i = state.user.selfEmojis.content.length - 1; i >= 0; i--) {
  //     const element = state.user.selfEmojis.content[i]
  //     if (element.uid === emoji.uid) {
  //       state.user.selfEmojis.content.splice(i, 1)
  //     }
  //   }
  //   state.user.selfEmojis.content.unshift(emoji)
  // },

  // 删除表情
  [types.DELETE_SELF_EMOJIS](state, { id }) {
    // state.user.selfEmojis.content.unshift(emoji)
    for (let i = state.user.selfEmojis.content.length - 1; i >= 0; i--) {
      const element = state.user.selfEmojis.content[i]
      if (element.id === id) {
        state.user.selfEmojis.content.splice(i, 1)
      }
    }
  },

  // 持久化图片
  [types.PERSIST_SELF_IMAGES](state, { images }) {
    state.user.selfImages = images
  },

  // 添加图片
  [types.ADD_SELF_IMAGES](state, { image }) {
    state.user.selfImages.content.unshift(image)
  },

  // 更新图片
  // [types.UPDATE_SELF_IMAGES](state, { image }) {
  //   // state.user.selfImages.content.unshift(image)
  //   for (let i = state.user.selfImages.content.length - 1; i >= 0; i--) {
  //     const element = state.user.selfImages.content[i]
  //     if (element.uid === image.uid) {
  //       state.user.selfImages.content.splice(i, 1)
  //     }
  //   }
  //   state.user.selfImages.unshift(image)
  // },

  // 删除图片
  [types.DELETE_SELF_IMAGES](state, { id }) {
    // state.user.selfImages.content.unshift(image)
    for (let i = state.user.selfImages.content.length - 1; i >= 0; i--) {
      const element = state.user.selfImages.content[i]
      if (element.id === id) {
        state.user.selfImages.content.splice(i, 1)
      }
    }
  },

  // 持久化文件
  [types.PERSIST_SELF_FILES](state, { files }) {
    state.user.selfFiles = files
  },

  // 添加文件
  [types.ADD_SELF_FILES](state, { file }) {
    state.user.selfFiles.content.unshift(file)
  },

  // 更新文件
  // [types.UPDATE_SELF_FILES](state, { file }) {
  //   // state.user.selfFiles.content.unshift(file)
  //   for (let i = state.user.selfFiles.content.length - 1; i >= 0; i--) {
  //     const element = state.user.selfFiles.content[i]
  //     if (element.uid === file.uid) {
  //       state.user.selfFiles.content.splice(i, 1)
  //     }
  //   }
  //   state.user.selfFiles.content.unshift(file)
  // },

  // 删除文件
  // [types.DELETE_SELF_FILES](state, { file }) {
  //   // state.user.selfFiles.unshift(file)
  //   for (let i = state.user.selfFiles.length - 1; i >= 0; i--) {
  //     const element = state.user.selfFiles[i]
  //     if (element.uid === file.uid) {
  //       state.user.selfFiles.splice(i, 1)
  //     }
  //   }
  // }

  [types.UPDATE_RIGHT_ACTIVE_TAB](state, { tab }) {
    state.right_active_tab = tab
  },

  [types.UPDATE_WECHAT_MP_BINDED](state, { binded }) {
    state.is_wechat_mp_binded = binded
  },

  [types.UPDATE_WECHAT_MP_PUSH_ENABLED](state, { enabled }) {
    state.is_wechat_mp_push_enabled = enabled
  },

  // 
  [types.UPDATE_CURRENT_THREAD_URL](state, { url, preUrl, title }) {
    state.user.current_thread_url = {
      url: url,
      preUrl: preUrl,
      title: title
    }
  }
}
